import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";

export function useCompletionsPerUser(fromDate: string, toDate: string) {
  return useQuery({
    queryKey: ["platformAnalytics", "completionsPerUser", fromDate, toDate],
    queryFn: () =>
      api.getCompletionsPerUser({ from_date: fromDate, to_date: toDate }),
  });
}
